<app-login [visible]="false"></app-login>
<nav class="navbar navbar-expand-lg navbar-light bg-light px-3">
    <a class="navbar-brand" href="https://www.encolate.es" target="_blank">
        <img src="./assets/img/logo.png" class="me-2">
    </a>
    <div class="navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto">

            <app-call *ngIf="!_data.deskStopped" (isCallLoading)="callLoading($event)"></app-call>

            <ng-container *ngIf="!isCallLoading">
                <app-stop-desk *ngIf="!_data.deskStopped && turn == null && _data.session['autosupervisor'] && _data.session['queuemode'] == 'Q'"></app-stop-desk>
                <app-phone *ngIf="turn == null && _data.configuration['phoneEnabled'] && isCallLoading == false && !_data.deskStopped"></app-phone>
                <app-cancel *ngIf="(turn != null && _data.configuration['cancelTurnButton']) || (_data.configuration['activeSupervisor'] && selectedTurn != null && selectedTurn['type'] == 'inAttention')">
                </app-cancel>
                <app-pause *ngIf="_data.session['pauseticket'] == true && _data.session['wmode'] != 'A'"></app-pause>
                <app-redirect *ngIf="turn != null && _data.session['redirect'] == true || (_data.configuration['activeSupervisor'] && selectedTurn != null && selectedTurn['type'] == 'inAttention')">
                </app-redirect>
                <app-atypes [buttonMode]="true" [isAttentionTurn]="selectedTurn != null && selectedTurn['type'] == 'inAttention'" [selectedTurn]="selectedTurn"></app-atypes>
                <app-recoverfinished *ngIf="selectedTurn != null && _data.configuration['activeSupervisor'] && _data.configuration['recoverFinishedTurn'] && selectedTurn['type'] == 'finished'">
                </app-recoverfinished>
                <app-delete *ngIf="turn == null && isCallLoading == false && _data.configuration['activeSupervisor'] && _data.configuration['deleteSupervisorDesk']">
                </app-delete>
                <app-redirect [withoutTurn]="true" *ngIf="_data.configuration['activeSupervisor'] && selectedTurn != null && selectedTurn['type'] != 'inAttention' && selectedTurn['type'] != 'finished'">
                </app-redirect>
                <app-postpone *ngIf="turn != null && _data.configuration['showPostponeButton'] && turn['plandate'] != null">
                </app-postpone>
                <app-changelistkind *ngIf="selectedTurn != null && _data.configuration['activeSupervisor'] && selectedTurn['type'] != 'inAttention' && selectedTurn['type'] != 'finished'">
                </app-changelistkind>
                <app-status [withButton]="true" *ngIf="turn != null && (_data.configuration['showQueueInfo'] || _data.configuration['showKindInfo'])">
                </app-status>
                <app-deskqueue *ngIf="turn == null && _data.configuration['queuedesk']"></app-deskqueue>
                <app-deskstatus *ngIf="_data.configuration['activeDesk']"></app-deskstatus>
            </ng-container>
            <ng-container *ngIf="isCallLoading">
                <i class="fa fa-spinner fa-spin fa-fw"></i>
            </ng-container>
        </ul>
        <ul class="navbar-nav">
            <li class="nav-item bg-light ps-1 me-2">
                <app-message *ngIf="(_data.configuration['chatEnabled'] || _data.configuration['alertEnabled']) && !_data.deskStopped" class="ms-2">
                </app-message>
            </li>
            <li class="nav-item bg-light ps-1 pe-1 me-2">
                <div class="dropdown">
                    <a type="button" id="dropdownMenu2" class="nav-link text-dark dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-user" aria-hidden="true"></i> {{
            _data.session["operator"] }}</a>
                    <div class="dropdown-menu dropdown-menu-end">
                        <form class="p-3">
                            <div class="alert alert-danger" *ngIf="loginComponent.hasError">{{ "incorrect" | language }}</div>
                            <div class="mb-3">
                                <label for="exampleDropdownFormEmail1">{{ "user" | language }}</label>
                                <input type="text" [(ngModel)]="user" [ngModelOptions]="{standalone: true}" class="form-control" id="exampleDropdownFormEmail1" [placeholder]="'user' | language">
                            </div>
                            <div class="mb-3">
                                <label for="exampleDropdownFormPassword1">{{ "pass" | language }}</label>
                                <input type="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="form-control" id="exampleDropdownFormPassword1" [placeholder]="'pass' | language">
                            </div>
                            <button type="submit" (click)="login()" class="btn btn-success float-end">{{ "join" | language }}</button>
                        </form>
                    </div>
                </div>
            </li>
            <li class="nav-item bg-light ps-2 pe-2 me-2">
                <a class="nav-link text-dark" href="#"><i class="fa fa-building" aria-hidden="true"></i>
                <span *ngIf="shouldShowOfficeId()">#{{ _data.session["office"] }}</span> {{ _data.session["officename"] }}</a>
            </li>
            <li class="nav-item bg-light ps-2 pe-2 me-2">
                <a class="nav-link text-dark" href="#"><i class="fa fa-desktop" aria-hidden="true"></i>
                <span *ngIf="shouldShowDeskId()">#{{_data.session["desk"] }}</span> {{ _data.session["deskname"] }}</a>
            </li>
            <li class="nav-item">
                <button (click)="logout()" class="btn btn-light border border-dark ms-1 me-1" href="#"><i class="fa fa-sign-out"
            aria-hidden="true"></i> {{ "exit" | language }}</button>
            </li>
        </ul>
    </div>
</nav>
